module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('span', {
    staticClass: "input-group-addon input-group-addon-color"
  }, [_vm._v(_vm._s(_vm.item.desc))]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "mynumber",
      rawName: "v-mynumber",
      value: ({
        class: ''
      }),
      expression: "{class:''}"
    }],
    staticClass: "form-control",
    attrs: {
      "title": _vm.item.unit,
      "type": "number",
      "min": _vm.item.min,
      "max": _vm.item.max,
      "step": _vm.item.step
    },
    domProps: {
      "value": (_vm.item.value * _vm.item.conversion).toFixed(2)
    },
    on: {
      "input": function($event) {
        _vm.item.value = $event.target.value / _vm.item.conversion
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3bee0962!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/number.vue
// module id = 94
// module chunks = 0